import * as Sentry from '@sentry/browser';

if (process.env.NODE_ENV !== 'development') {
  Sentry.init(window.SENTRY_OPTIONS);
  Sentry.configureScope((scope) => {
    scope.setUser(window.SENTRY_USER);
  });
}
